import React, {useEffect, useState, Fragment} from "react";
import {Col, Container, Row} from "react-bs4grid";
import {withRouter, Link} from "react-router-dom";

import AppContainer from "../AppContainer/AppContainer";
import axiosInstance from "../../apiPromises/axiosInstance";
import useAppState from "../../common/StateMachine/useAppState";

import "./profile.scss";
import {useTranslation} from "react-i18next";

const Profile = props => {
    const accountState = useAppState("account");
    const account = accountState.state;
    const [userProfile, setUserProfile] = useState({});
    const {t} = useTranslation();

    useEffect(() => {
        axiosInstance.get("/users/current").then(res => {
            setUserProfile(res.data);
        });
    }, []);

    return (
        <AppContainer>
            {account && userProfile.userId && (
                <Fragment>
                    <Container className="mt-16">
                        <Row
                            className="pb-8 pt-16"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Col style={{display: "flex", justifyContent: "center"}}>
                                {userProfile.profilePhotoPath ? (
                                    <img
                                        className="avatar-placeholder"
                                        src={userProfile.profilePhotoPath}
                                        alt="uploaded preview"
                                    />
                                ) : (
                                    <img
                                        className="avatar-placeholder"
                                        src="/default-profile-picture.jpg"
                                        alt="profile placeholder"
                                    />
                                )}
                            </Col>
                        </Row>
                        <Row className="pt-8" justifyContent="center" alignItems="center">
                            <Col style={{display: "flex", justifyContent: "center"}}>
                                <div className="job-details-content">
                                    <h1 style={{marginBottom: "0"}}>{t("myPlastxProfile")}</h1>
                                </div>
                            </Col>
                        </Row>
                        <Row justifyContent="center" alignItems="center">
                            <Col style={{display: "flex", justifyContent: "center"}}>
                                <div className="job-details-content">
                                    <Link to="/user/edit-profile">
                                        <h3 style={{color: "#ff7043", marginBottom: "0"}}>{t("editAccount")}</h3>
                                    </Link>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{display: "flex", justifyContent: "center"}}>
                                <div className="job-details-content">
                                    <h4>{t("yourAuthorizedPlastxId")}: {userProfile.userId}</h4>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container fluid className="jobs-list-container">
                        <Row
                            className="jobs-list"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Col w="auto">
                                <div className="profile-section pt-32 pb-16">
                                    <div className="profile-icon-wrapper">
                                        <img src="/icon-profile.svg" alt="icon profile"/>
                                    </div>
                                    <div>
                                        <div>{t("name")}:</div>
                                        <div className="profile-value">{userProfile.fullName}</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row
                            className="jobs-list"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Col w="auto">
                                <div className="profile-section pt-32 pb-16">
                                    <div className="profile-icon-wrapper">
                                        <img src="/icon-email.svg" alt="icon email"/>
                                    </div>
                                    <div>
                                        <div>{t("username")}:</div>
                                        <div className="profile-value">{userProfile.email}</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row
                            className="jobs-list"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Col w="auto">
                                <div className="profile-section pt-32 pb-16">
                                    <div className="profile-icon-wrapper">
                                        <img src="/icon-id.svg" alt="icon id"/>
                                    </div>
                                    <div>
                                        <div>{t("yourAuthorizedPlastxId")}:</div>
                                        <div className="profile-value">{userProfile.userId}</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row
                            className="jobs-list"
                            justifyContent="center"
                            alignItems="center">
                            <Col w="auto">
                                <div className="profile-section pt-32 pb-16">
                                    <div className="profile-icon-wrapper">
                                        <img src="/icon-location.svg" alt="icon location"/>
                                    </div>
                                    <div>
                                        <div>{t("location")}:</div>
                                        <div className="profile-value">
                                            {userProfile.location.fullAddress}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row
                            className="jobs-list pb-48"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Col w="auto">
                                <div className="profile-section pt-32 pb-16">
                                    <div className="profile-icon-wrapper">
                                        <img src="/icon-phone.svg" alt="icon phone"/>
                                    </div>
                                    <div>
                                        <div>{t("phoneNumber")}:</div>
                                        <div className="profile-value">
                                            {userProfile.phoneNationalNumber}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {/*QR code disabled for now*/}
                        {/*<Row justifyContent="center" alignItems="center">*/}
                        {/*  <Col w="auto">*/}
                        {/*    <Link to="/user/my-qr-code/">*/}
                        {/*      <Button className="mt-32 mb-32" text="Launch your QR Code" />*/}
                        {/*    </Link>*/}
                        {/*  </Col>*/}
                        {/*</Row>*/}
                        {/*<Row className="pb-96" justifyContent="center" alignItems="center">*/}
                        {/*  <Col w="auto">*/}
                        {/*    <span>Show your QR code when you make a delivery.</span>*/}
                        {/*  </Col>*/}
                        {/*</Row>*/}
                    </Container>
                </Fragment>
            )}
        </AppContainer>
    );
};

export default withRouter(Profile);
